import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/pro/:nama',   // :nama adalah parameter dinamis
    name: 'pro',
    component: () => import('../views/SellerShopIdView.vue')
  },
  // ========== TAMBAHKAN ROUTE DI BAWAH INI ==========
  {
    path: '/landing',
    name: 'LandingPage',
    component: () => import('../views/LandingPage.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/DashboardAdmin.vue')
  }
  // ========== SAMPAI SINI ==========
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router